import { render, staticRenderFns } from "./OverridesList.vue?vue&type=template&id=74bcec20&scoped=true&"
import script from "./OverridesList.vue?vue&type=script&lang=js&"
export * from "./OverridesList.vue?vue&type=script&lang=js&"
import style0 from "./OverridesList.vue?vue&type=style&index=0&id=74bcec20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bcec20",
  null
  
)

export default component.exports